module.exports = __webpack_public_path__ + "static/media/ringtone.6c75513d.wav";